import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import './Contact.css';
import teamImage from '../../assets/images/team.jpg';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    success: false,
    message: ''
  });
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate a successful submission locally without hitting a backend
    await new Promise(resolve => setTimeout(resolve, 600));

    setFormStatus({
      submitted: true,
      success: true,
      message: 'Thanks for reaching out! Drop us a line at hello@digitalfig.com for the fastest response.'
    });

    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });

    setIsSubmitting(false);

    // Reset status after a short delay
    setTimeout(() => {
      setFormStatus({
        submitted: false,
        success: false,
        message: ''
      });
    }, 5000);
  };
  
  return (
    <section id="contact" className="contact section">
      <div className="container">
        <motion.div 
          className="section-title"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>Contact</h2>
          <p>Get in touch for project enquiries</p>
        </motion.div>
        
        <div className="contact-content">          <motion.div 
            className="contact-info"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >            <div className="team-section">
              <div className="team-image-container">
                <img src={teamImage} alt="Digital Fig team" className="team-img" />
              </div>
            </div>
            
            <div className="info-item">
              <div className="icon">
                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              <div className="details">
                <h4>Email</h4>
                <p>hello@digitalfig.com</p>
              </div>
            </div>
            
            <div className="info-item">
              <div className="icon">
                <FontAwesomeIcon icon={faLocationDot} />
              </div>
              <div className="details">
                <h4>Location</h4>
                <p>London, UK</p>
              </div>
            </div>
            
            <motion.div 
              className="marketing-message"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              <h3>Promote Your Brand Across Our Entire Network</h3>
              <p>
                At Digital Fig, we offer advertising opportunities across all our projects—giving your business or brand maximum exposure to our diverse and engaged audiences.
              </p>
              <p>
                Want to learn more? Reach out to us at <a href="mailto:hello@digitalfig.com">hello@digitalfig.com</a>.
              </p>
            </motion.div>
          </motion.div>
          
          <motion.div 
            className="contact-form-container"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            {formStatus.submitted ? (
              <div className={`form-message ${formStatus.success ? 'success' : 'error'}`}>
                {formStatus.message}
              </div>
            ) : (
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="whatsapp-message">
                  <h4>Prefer Instant Communication?</h4>
                  <p>WhatsApp offers the quickest way to reach us for immediate project discussions and consultations. Simply tap the green WhatsApp icon below and one of our team members will respond promptly.</p>
                </div>
                
                <div className="form-group">
                  <input 
                    type="text" 
                    name="name" 
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <input 
                    type="email" 
                    name="email" 
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <input 
                    type="text" 
                    name="subject" 
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <textarea 
                    name="message" 
                    placeholder="Your Message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>
                
                <button type="submit" className="btn primary-btn" disabled={isSubmitting}>
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
